import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageBase } from '../../model/language';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { BehaviorSubject } from 'rxjs';
import { SegmentService } from 'src/app/modules/settings/services/segment.service';
import { Envelope } from '../../model/envelope';

@Component({
  selector: 'app-envelope-list-card-content',
  templateUrl: './envelope-list-card-content.component.html',
  styleUrls: ['./envelope-list-card-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EnvelopeListCardContentComponent implements OnInit {

  @Input() envelope: Envelope;

  languageBase: LanguageBase;
  sentEnvelopeStatus = SentEnvelopeStatus;
  segment = new BehaviorSubject<any>(undefined);

  constructor(private translate: TranslateService, private segmentService: SegmentService) {
    this.languageBase = new LanguageBase(translate);
  }

  ngOnInit() {
  }

  getDateFormat() {
    return this.languageBase.getDateFortmatByLanguage(this.translate.currentLang);
  }

}
